import { render, staticRenderFns } from "./gift.vue?vue&type=template&id=3db5e6aa&scoped=true&"
import script from "./gift.vue?vue&type=script&lang=js&"
export * from "./gift.vue?vue&type=script&lang=js&"
import style0 from "./gift.vue?vue&type=style&index=0&id=3db5e6aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db5e6aa",
  null
  
)

export default component.exports